<div class='container'>
    <div fxFlex fxLayout="column" fxLayoutGap="15px">
        <syn-audit-history
            [loading]="loading"
            [logs]="logs"
            [selectedLogId]="log?.id"
            [pagination]="pagination"
            [title]="title"
            (select)="selectLog($event)"
            (filter)="setFilters($event)"
            (paginate)="setPagination($event)"
        ></syn-audit-history>

        <syn-page-loader [loading]="log === undefined && loadingLog"></syn-page-loader>

        <syn-audit-diff *ngIf="log"
                        [log]="log"
                        [previousLog]="previousLog"
                        [nextLog]="nextLog"
                        [loading]="loadingLog"
                        (loadPreviousLog)="loadPreviousLog()"
                        (loadNextLog)="loadNextLog()"
        ></syn-audit-diff>
    </div>
</div>
